module.exports = __webpack_public_path__ + "static/media/Treadmill.f9d055ed.svg";